const classes = [
    {
        id: 'c1',
        mongoId: '64eac850d5dd91c5ae3596ab',
        imageUrl: 'Dada and Me.jpg',
        name: 'Dada and me',
        subtitles: [
            'Online Class (3-6 years old)',
        ],
        bulletPoints: [
            'High interactive learning materials',
            'Features songs, rhymes, games, stories, etc.',
            'Fun and practical content'
        ],
        price: 80.00,
        book: 'cart'
    },
    {
        id: 'c2',
        mongoId: '64eac865db9cf515f60e6b51',
        imageUrl: 'Dada and We.jpg',
        name: 'Dada and we',
        subtitles: [
            'Online group lesson (5-8 years old)',
            'In person lesson (limited spots)'
        ],
        bulletPoints: [
            'Small class size between 2-5',
            'Immersive Chinese language environment',
            'Learn through meaningful conversations',
            'Engaging with experienced teacher and similar level peers'
        ],
        price: 120.00,
        book: 'cart'
    },
    {
        id: 'c3',
        mongoId: '64eac87954c33473712348b5',
        imageUrl: 'Dadada.jpg',
        name: 'Dadada',
        subtitles: [
            '1 - 1 tutoring'
        ],
        bulletPoints: [
            'For individuals with personal goals',
            '1 on 1 attention for faster improvement and better result',
            'Tailored lesson plans based on students learning style',
            'Flexible schedule suitable for busy individuals'
        ],
        price: '60 - 100',
        book: 'calendly'
    },
];

export default classes;